import useRequest from '@/composables/use-request'
import { getCasServiceUrl, getLoginEntryUrl } from '@/utils/auth-redirect'

const baseUrl = '/api'
const { get, post } = useRequest()

// 登出请求
export async function logout() {
  return get<any>(`${baseUrl}/cas/logout`)
}

// 没有token时获取token和用户信息
export async function getRdxToken<T>() {
  return post<T>(`${baseUrl}/blade-auth/cas/token?grant_type=cas`)
}
// 获取用户权限组
export async function getPermissionGroup(userId?: string) {
  return get<string[]>(`${baseUrl}/blade-auth/cas/getPermissionGroupList`, { userId })
}
// 从bo端直接登录后获取用户信息
export async function getTokenObject<T>() {
  return get<T>(`${baseUrl}/blade-auth/cas/getTokenObject`)
}
// tgc续期请求
export async function loginTgc<T>() {
  return get<T>(getLoginEntryUrl())
}

export { getCasServiceUrl, getLoginEntryUrl }
